// extracted by mini-css-extract-plugin
module.exports = {"overlay":"DashboardModal_overlay__2LlhI","content":"DashboardModal_content__2BXBp","closeButton":"DashboardModal_closeButton__1MP3K","container":"DashboardModal_container__1BvBz"};